import { Skeleton as MantineSkeleton, SkeletonProps } from '@mantine/core';

export type ISkeletonProps = SkeletonProps;

/** @registry Design-layer pass-through over Mantine Skeleton; import this instead of @mantine/core Skeleton outside src/design. */
export const Skeleton = MantineSkeleton;
